// Explore-stats page: Military service of parliamentarians.
// Sourced from recordsofservice ROSTypeID=16 entries, joined to
// parliamentarians for party/state/parliament. One row per veteran PHID.

import React, { useState, useEffect } from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatBar } from './charts';

export default function MilitaryService() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('military-service');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Military service of parliamentarians"
      description={`Parliamentarians whose Handbook record carries Military Service entries${
        charts.total ? ` (${charts.total})` : ''
      } — branch, era and per-parliament veteran count.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="military-service-parliamentarians"
    >
      {data && (
        <>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>By branch</Typography>
                <StatBar data={charts.by_branch || []} xKey="branch" yKey="count"
                         layout="vertical" height={260} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>By conflict era</Typography>
                <StatBar data={charts.by_era || []} xKey="era" yKey="count"
                         layout="vertical" height={260} />
              </Paper>
            </Grid>
          </Grid>
          <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>By Parliament</Typography>
            <StatBar data={charts.by_parliament || []} xKey="parliament"
                     yKey="count" />
          </Paper>
        </>
      )}
    </ExploreStatsPage>
  );
}
